import React from "react";
import { Col, Row } from "react-bootstrap";

const SetupCompleteMessage = () => {
  return (
    <Row className="mb-3">
      <Col sm={12}>
        <div className="bordered-box font-secondary d-flex flex-column">
          <div className="text-gray fw-bold px-4 py-2">Setup Complete!</div>
          <div className="text-gray font-weight-normal px-4 py-2">
            As a reminder, we deposit into your personal account twice a month
            to offset your ESPP payroll deductions. We initiate a deposit on the
            1st and 15th of every month.
          </div>
          <div className="text-gray font-weight-normal px-4 py-2">
            Questions? Email{" "}
            <a href="mailto:support@taabl.co">
              <u>support@taabl.co</u>
            </a>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default SetupCompleteMessage;
